// Lightweight inline icons — kept local so the project doesn't need an
// extra icon-library dependency. `currentColor` lets each usage tint itself.

export const LeafIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <path d="M4 20c0-8 4-14 16-16-2 12-8 16-16 16Z" strokeLinejoin="round" />
    <path d="M6 18c3-4 6-7 12-12" strokeLinecap="round" />
  </svg>
);

export const DropletIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <path
      d="M12 3c4 5 7 8.5 7 12a7 7 0 1 1-14 0c0-3.5 3-7 7-12Z"
      strokeLinejoin="round"
    />
  </svg>
);

export const CarIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <path
      d="M4 16v-2.5L6 8.5A2 2 0 0 1 7.9 7h8.2A2 2 0 0 1 18 8.5l2 5V16"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <rect x="2.5" y="16" width="19" height="4" rx="1.4" />
    <circle cx="7" cy="20" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="17" cy="20" r="1.4" fill="currentColor" stroke="none" />
  </svg>
);

export const PinIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <path
      d="M12 21s7-6.3 7-11.5A7 7 0 0 0 5 9.5C5 14.7 12 21 12 21Z"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="9.5" r="2.4" />
  </svg>
);

export const PhoneIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <path
      d="M6.5 3.5h3l1.5 4-2 1.6a12 12 0 0 0 5.9 5.9l1.6-2 4 1.5v3a1.5 1.5 0 0 1-1.6 1.5A16.5 16.5 0 0 1 4 5.1 1.5 1.5 0 0 1 5.5 3.5Z"
      strokeLinejoin="round"
    />
  </svg>
);

export const MailIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2.2" />
    <path d="m4 6.5 8 6 8-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SparkleIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2c.7 3.9 2.2 5.4 6 6-3.8.6-5.3 2.1-6 6-.7-3.9-2.2-5.4-6-6 3.8-.6 5.3-2.1 6-6Z" />
  </svg>
);

export const LockIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <rect x="5" y="10.5" width="14" height="9.5" rx="2" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" strokeLinecap="round" />
  </svg>
);
